/* eslint-disable arrow-parens */
/* eslint-disable react/jsx-one-expression-per-line */
import React, { useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { Form } from '@unform/web';
import * as Yup from 'yup';

import Input from '../../components/Input';
import logo from '../../assets/images/logo-apollo.png';
import { Container } from './styles';

import { signInRequest } from '~/store/modules/auth/actions';

export default function SignIn() {
  const formRef = useRef(null);
  const dispatch = useDispatch();
  const loading = useSelector((state) => state.auth.loading);

  async function handleSubmit(data) {
    const { email, password } = data;
    try {
      // Remove all previous errors
      formRef.current.setErrors({});
      const schema = Yup.object().shape({
        email: Yup.string()
          .email('Insira um e-mail válido.')
          .required('O e-mail é obrigatório.'),
        password: Yup.string()
          // .min(6)
          .required('A senha é obrigatória.'),
      });
      await schema.validate(data, {
        abortEarly: false,
      });
      // Validation passed
      dispatch(signInRequest(email, password));
    } catch (err) {
      const validationErrors = {};
      if (err instanceof Yup.ValidationError) {
        err.inner.forEach((error) => {
          validationErrors[error.path] = error.message;
        });
        formRef.current.setErrors(validationErrors);
      }
    }
  }

  return (
    <Container>
      <img src={logo} alt="Apollo" />

      <Form ref={formRef} onSubmit={handleSubmit}>
        <Input name="email" type="email" placeholder="E-mail" />
        <Input name="password" type="password" placeholder="Senha" />
        <Link to="/forgotpassword">Esqueci minha senha</Link>

        <button type="submit">{loading ? 'CARREGANDO...' : 'ENTRAR'}</button>
        <p style={{ color: '#fff', marginTop: 10 }}>
          Nāo tem uma conta?{' '}
          <Link to="/register" style={{ marginLeft: 3 }}>
            {' '}
            Cadastre-se
          </Link>
        </p>
      </Form>
      <a
        className="site"
        href="https://www.apollopartners.com.br"
        target="_blank"
        rel="noopener noreferrer"
      >
        Acessar apollopartners.com.br
      </a>
    </Container>
  );
}
